<template>
  <div>
    <q-form ref="form">
      <q-option-group :options="options" type="radio" v-model="group" />
      <q-slide-transition>
        <q-input
          :rules="[(v) => !!v || 'Field is Required']"
          label="Description"
          filled
          v-show="group == 'Other'"
          v-model="otherText"
          type="textarea"
        ></q-input>
      </q-slide-transition>
      <div class="row justify-end">
        <sustainability-button
          v-if="!isFeedbackLoading"
          class="bg-primary"
          width="108px"
          height="26px"
          borderRadius="3px"
          @click="supplierForm = !supplierForm"
        >
          <div class="row justify-center items-center full-height">
            <div @click="submitFeedback" class="buttonText text-white">
              Submit
            </div>
          </div>
        </sustainability-button>
        <q-circular-progress
          v-else
          indeterminate
          size="30px"
          color="primary"
          class="self-end"
        />
      </div>
    </q-form>
  </div>
</template>

<script>
  import SustainabilityButton from "@/components/sustainabilityButton/sustainabilityButton.vue";
  export default {
    components: {
      SustainabilityButton,
    },
    data: () => ({
      isFeedbackLoading: false,
      otherText: "",
      group: null,
      options: [
        {
          label: "Website doesn't exist",
          value: "Website doesn't exist",
        },
        {
          label: "Company doesn't exist",
          value: "Company doesn't exist",
        },
        {
          label: "Not a great fit for solution",
          value: "Not a great fit for solution",
        },
        {
          label: "Other",
          value: "Other",
        },
      ],
    }),
    methods: {
      async submitFeedback() {
        if (this.group) {
          let payload = {
            solutions_id: this.$route.params.id,
            option: this.group,
            text: this.otherText,
          };
          if (this.group == "Other" && this.otherText) {
            const isValid = await this.$refs.form.validate();
            if (isValid) {
              let result = await this.$store.dispatch(
                "mailing/dislikeFeedback",
                payload
              );
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
                this.isLoading = false;
                this.closeForm();
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
                this.isLoading = false;
              }
            }
          } else {
            let result = await this.$store.dispatch(
              "mailing/dislikeFeedback",
              payload
            );
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
              this.isLoading = false;
              this.closeForm();
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
              this.isLoading = false;
            }
          }
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Please select an Option",
          });
        }
      },
      closeForm() {
        this.$emit("close");
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
